import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { EtiquetaGerada } from '../../types/etiquetas';
import { etiquetasService } from '../../services';

const parseDados = (dados: EtiquetaGerada['dados']): Record<string, any> | null => {
  if (!dados) return null;
  if (typeof dados === 'string') {
    try {
      return JSON.parse(dados);
    } catch {
      return null;
    }
  }
  return dados;
};

const columns: ResourceColumn<EtiquetaGerada>[] = [
  {
    header: 'Data',
    accessor: 'created_at',
    render: (item) => {
      const parsedDados = parseDados(item.dados);
      return parsedDados?.data || item.created_at || '-';
    },
  },
  { header: 'Quantidade', accessor: 'quantidade' },
  { header: 'Tamanho', accessor: 'tamanho_etiqueta' },
  { header: 'Modo', accessor: 'modo_codigo' },
  {
    header: 'Origem',
    accessor: 'source_config',
    render: (item) => item.source_config?.url || 'Manual',
  },
];

export const EtiquetasListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Etiquetas Geradas"
      description="Histórico de etiquetas geradas no sistema."
      columns={columns}
      service={etiquetasService}
      createPath="/admin/producao/etiquetas/novo"
      onEdit={(item) => item.id && navigate(`/admin/producao/etiquetas/${item.id}`)}
    />
  );
};
